import { observable, action, makeObservable } from "mobx";

class PageStore {

    constructor() {
        makeObservable(this);
    }

    /*********************/
    /* 페이징 객체         */
    /*********************/
    /**
     * 페이징 객체
     * @type {{page_no: number, max_page: number}}
     * @private
     */
    @observable
    _st_paging_info = {
        page_no : 1,
        max_page : 1
    }

    /**
     * 페이징 객체 조회
     * @returns {{page_no: number, max_page: number}}
     */
    get getPagingInfo() {
        return this._st_paging_info;
    }

    @action
    initPaging(){
        this._st_paging_info = {
            page_no : 1,
            max_page : 1
        }
    }

    /**
     * 페이징 객체 값 셋팅
     * @param key
     * @param value
     */
    @action
    setPagingInfo(key, value) {
        this._st_paging_info = {...this._st_paging_info, [key]:value};
    }

    /**
     * 다음페이지 이동
     */
    @action
    nextPage() {
        const max_page = this._st_paging_info.max_page;
        let page_no = this._st_paging_info.page_no;

        if ( page_no<max_page ) {
            this._st_paging_info.page_no = (page_no + 1)
        }
    }

    /**
     * 이전페이징 이동
     */
    @action
    prevPage() {
        let page_no = this._st_paging_info.page_no;
        if ( page_no>1 ) {
            this._st_paging_info.page_no = (page_no - 1)
        }
    }

    /*********************/
    /* 왼쪽 메뉴 페이징 객체 */
    /*********************/
    /**
     * 페이징 객체
     * @type {{page_no: number, max_page: number}}
     * @private
     */
    @observable
    _st_left_paging_info = {
        page_no : 1,
        max_page : 1
    }

    /**
     * 페이징 객체 조회
     * @returns {{page_no: number, max_page: number}}
     */
    get getLeftPagingInfo() {
        return this._st_left_paging_info;
    }

    /**
     * 페이징 객체 값 셋팅
     * @param key
     * @param value
     */
    @action
    setLeftPagingInfo(key, value) {
        this._st_left_paging_info = {...this._st_left_paging_info, [key]:value};
    }

    /**
     * 다음페이지 이동
     */
    @action
    nextLeftPage() {
        const max_page = this._st_left_paging_info.max_page;
        let page_no = this._st_left_paging_info.page_no;

        if ( page_no<max_page ) {
            this._st_left_paging_info.page_no = (page_no + 1)
        }
    }

    /**
     * 이전페이징 이동
     */
    @action
    prevLeftPage() {
        let page_no = this._st_left_paging_info.page_no;
        if ( page_no>1 ) {
            this._st_left_paging_info.page_no = (page_no - 1)
        }
    }

    @action
    initLeftPaging(){
        this._st_left_paging_info = {
            page_no : 1,
            max_page : 1
        }
    }

}

export default new PageStore();